import React, {
    Component,
    PropTypes
} from 'react';
import {resultTip,language} from 'UTIL/common'
import userService from 'SERVICES/ella/userService'
import BoxHeader from "CONFIG/component/boxHeader"
import Tip from 'COMPONENT/tip'
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
var log, className = "dark";
var newCount = 1;
import ZtreeInput from 'COMPONENT/form/ztreeInput'
export default class OrgStructure extends Component {
    constructor(props) {
        super(props);
        this.getNodeTree = this.getNodeTree;
        this.addHoverDom = this.addHoverDom;
        this.removeHoverDom = this.removeHoverDom;
        this.showRemoveBtn = this.showRemoveBtn;
        this.showRenameBtn = this.showRenameBtn;
        this.beforeDrag = this.beforeDrag;
        this.beforeEditName = this.beforeEditName;
        this.beforeRemove = this.beforeRemove;
        this.beforeRename = this.beforeRename;
        this.onRemove = this.onRemove.bind(this);
        this.onRename = this.onRename.bind(this);
        this.getTime = this.getTime.bind(this);
        this.submit = this.submit.bind(this);
        this.submitAdd = this.submitAdd.bind(this);
        this.onClick = this.onClick.bind(this);
        this.treeData = this.treeData.bind(this);
        this.state = {
            data: [],
            pageSize: 10,
            page: 1,
            total: 0,
            delRow: {},
            expandId:'',
        }
    };

    componentDidMount() {
        this.treeData();
    }


    getNodeTree(zNodes) {
        const setting = {
            view: {
                addHoverDom: this.addHoverDom,
                removeHoverDom: this.removeHoverDom,
                selectedMulti: false
            },
            edit: {
                enable: true,
                showRemoveBtn: this.showRemoveBtn,
                showRenameBtn: this.showRenameBtn
            },
            data: {
                simpleData: {
                    enable: true
                }
            },
            callback: {
                beforeDrag: this.beforeDrag,
                beforeEditName: this.beforeEditName,
                beforeRemove: this.beforeRemove,
                beforeRename: this.beforeRename,
                onRemove: this.onRemove,
                onRename: this.onRename,
                onClick: this.onClick,
            }
        };
        $.fn.zTree.init($("#treeDemo"), setting, zNodes);
        var treeObj = $.fn.zTree.getZTreeObj("treeDemo");
        var treenode = treeObj.getNodeByParam("id", this.state.expandId, null);
        treeObj.expandNode(treenode, true,false);
        treeObj.selectNode(treenode);
    }

    onClick(event, treeId, treeNode) {
        console.log(treeNode,treeId);
        if (treeNode.id < 100000) {
            $("#editDiv").removeClass("hidden");
            $("#addDiv").addClass("hidden");
            var id = treeNode.id;
            userService.getOrgInfo(id).then(data => {
                const json = data.data;
                console.log(json)
                json.level == undefined ? $("#level").val("") : $("#level").val(json.level);
                json.name == undefined ? $("#name").val("") : $("#name").val(json.name);
                json.id == undefined ? $("#id").val("") : $("#id").val(json.id);
                json.parentId == undefined ? $("#parentId").val("") : $("#parentId").val(json.parentId);
                json.shortName == undefined ? $("#shortName").val("") : $("#shortName").val(json.shortName);
                json.enName == undefined ? $("#enName").val("") : $("#enName").val(json.enName);
                json.abbreviation == undefined ? $("#abbreviation").val("") : $("#abbreviation").val(json.abbreviation);
                json.number == undefined ? $("#number").val("") : $("#number").val(json.number);
            })
        } else {
            $("#editDiv").addClass("hidden");
            $("#addDiv").removeClass("hidden");
            $("#idAdd").val(treeNode.id);
            $("#nameAdd").val(treeNode.name);
            $("#levelAdd").val(treeNode.level);
            $("#parentIdAdd").val(treeNode.pId);
            $("#enNameAdd").val("")
            $("#shortNameAdd").val("");
            $("#numberAdd").val("");
            $("#abbreviationAdd").val("");
        }
    }

    beforeDrag(treeId, treeNodes) {
        return false;
    }

    beforeEditName(treeId, treeNode) {
        const self = this;
        className = (className === "dark" ? "" : "dark");
        var zTree = $.fn.zTree.getZTreeObj("treeDemo");
        zTree.selectNode(treeNode);
        setTimeout(function () {
            if (confirm("进入节点 -- " + treeNode.name + " 的编辑状态吗？")) {
                if (treeNode.id < 100000) {
                    $("#editDiv").removeClass("hidden");
                    $("#addDiv").addClass("hidden");
                    userService.getOrgInfo(treeNode.id).then(data => {
                        const json = data.data;
                        json.level == undefined ? $("#level").val("") : $("#level").val(json.level);
                        json.id == undefined ? $("#id").val("") : $("#id").val(json.id);
                        json.parentId == undefined ? $("#parentId").val("") : $("#parentId").val(json.parentId);
                        json.name == undefined ? $("#name").val("") : $("#name").val(json.name);
                        json.shortName == undefined ? $("#shortName").val("") : $("#shortName").val(json.shortName);
                        json.enName == undefined ? $("#enName").val("") : $("#enName").val(json.enName);
                        json.abbreviation == undefined ? $("#abbreviation").val("") : $("#abbreviation").val(json.abbreviation);
                        json.number == undefined ? $("#number").val("") : $("#number").val(json.number);
                    })
                } else {
                    $("#editDiv").addClass("hidden");
                    $("#addDiv").removeClass("hidden");
                    $("#idAdd").val(treeNode.id);
                    $("#nameAdd").val(treeNode.name);
                    $("#levelAdd").val(treeNode.level);
                    $("#parentIdAdd").val(treeNode.pId);
                }
            }
        }, 0);
        return false;
    }

    beforeRemove(treeId, treeNode) {
        className = (className === "dark" ? "" : "dark");
        var zTree = $.fn.zTree.getZTreeObj("treeDemo");
        zTree.selectNode(treeNode);
        return confirm(language()['deleteNode']+"-- " + treeNode.name + "？");
    }

    onRemove(e, treeId, treeNode) {
        if (treeNode.id < 100000) {
            userService.deleteOrgInfo(treeNode.id).then(data => {
                if (data.code == 8001) {
                    $("#success_msg").text(data.msg);
                    $("#success_tip").removeClass("hidden");
                    setTimeout(function () {
                        $("#success_tip").addClass("hidden");
                    }, 3000);
                } else {
                    $("#error_msg").text(data.msg);
                    $("#error_tip").removeClass("hidden");
                    setTimeout(function () {
                        $("#error_tip").addClass("hidden");
                    }, 3000);
                }
            })
        }
        return;
    }

    beforeRename(treeId, treeNode, newName, isCancel) {
        className = (className === "dark" ? "" : "dark");
        if (newName.length == 0) {
            setTimeout(function () {
                var zTree = $.fn.zTree.getZTreeObj("treeDemo");
                zTree.cancelEditName();
                alert(language()['nodeNotEmpty']+'!');
            }, 0);
            return false;
        }
        return true;
    }

    onRename(e, treeId, treeNode, isCancel) {
        return;
    }

    showRemoveBtn(treeId, treeNode) {
        return !(treeNode.id == 1);
    }

    showRenameBtn(treeId, treeNode) {
        return !(treeNode.id == 1);
    }

    getTime() {
        var now = new Date(),
            h = now.getHours(),
            m = now.getMinutes(),
            s = now.getSeconds(),
            ms = now.getMilliseconds();
        return (h + ":" + m + ":" + s + " " + ms);
    }

    addHoverDom(treeId, treeNode) {

        var sObj = $("#" + treeNode.tId + "_span");
        if (treeNode.editNameFlag || $("#addBtn_" + treeNode.tId).length > 0) return;
        var addStr = "<span class='button add' id='addBtn_" + treeNode.tId + "' title='add node' onfocus='this.blur();'></span>";
        sObj.after(addStr);
        var btn = $("#addBtn_" + treeNode.tId);
        if (btn) btn.bind("click", function () {
            var zTree = $.fn.zTree.getZTreeObj("treeDemo");
            zTree.addNodes(treeNode, {
                id: (100000 + newCount),
                pId: treeNode.id,
                name: "new node" + (newCount++),
                level: treeNode.level + 1,
            });
            return false;
        });
    };

    removeHoverDom(treeId, treeNode) {
        $("#addBtn_" + treeNode.tId).unbind().remove();
    };

    submit(event) {
        event.preventDefault();
        var arr = {
            "level": $("#level").val(),
            "id": $("#id").val(),
            "parentId": $("#parentId").val(),
            "name": $("#name").val(),
            "shortName": $("#shortName").val(),
            "enName": $("#enName").val(),
            "abbreviation": $("#abbreviation").val(),
            "number": $("#number").val(),
        };
        var data = JSON.stringify(arr);
        userService.saveOrgInfo({data}).then(body => {
            if (body.code == 8001) {
                this.setState({
                    expandId:arr.id
                },()=>{
                    this.treeData();
                    $("#success_msg").text(body.msg);
                    $("#success_tip").removeClass("hidden");
                    $("#success_tip").focus();
                    setTimeout(function() {
                        $("#success_tip").addClass("hidden");
                    }, 3000);
                })

            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                $("#error_tip").focus();
                setTimeout(function() {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
        })
    }

    submitAdd(event) {
        event.preventDefault();
        var arr = {
            "level": $("#levelAdd").val(),
            "parentId": $("#parentIdAdd").val(),
            "name": $("#nameAdd").val(),
            "shortName": $("#shortNameAdd").val(),
            "enName": $("#enNameAdd").val(),
            "abbreviation": $("#abbreviationAdd").val(),
            "number": $("#numberAdd").val(),
        };
        var data = JSON.stringify(arr);
        userService.saveOrgInfo({data}).then(body => {
            if (body.code == 8001) {
                this.setState({
                    expandId:body.data
                },()=>{
                    this.treeData();
                    $("#success_msg").text(body.msg);
                    $("#success_tip").removeClass("hidden");
                    $("#success_tip").focus();
                    setTimeout(function() {
                        $("#success_tip").addClass("hidden");
                    }, 3000);
                })

            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                $("#error_tip").focus();
                setTimeout(function() {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
        })
    }
    treeData(){
        userService.fetchOrg().then(data => {
            if (data.data != null) {
                const json = data.data;

                const nodeList = json.nodeVos;
                this.setState({
                    data: nodeList
                });
                this.getNodeTree(nodeList);
            }
        })
    }

    render() {
        return (
            <div >
                <ContentHeader nameLg="organizationStructure" nameSm="CreateOrganizationalStructures"/>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-list"></i>
                            <h3 className="box-title">{language()['CreateOrganizationalStructures']}</h3>

                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div className=" col-sm-4">
                                <input type="hidden" id="nodes"/>
                                <ul id="treeDemo" className="ztree" style={{width: "260px"}}></ul>
                            </div>

                            <div className="col-sm-8 hidden" id="editDiv">
                                <form id="editForm" className="form-horizontal">
                                    {/********父类ID*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['level']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="level" name="level"
                                                       disabled="true"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********父类ID*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['parentId']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="parentId"
                                                       name="parentId" disabled="true"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********ID*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> ID
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="id" name="id"
                                                       disabled="true"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********架构名称*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['SchemaName']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="name" name="name"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********中文简称*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['shortName']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="shortName"
                                                       name="shortName"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********英文名称*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['enName']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="enName" name="enName"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********英文简称*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['abbreviation']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="abbreviation"
                                                       name="abbreviation"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********架构编号*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['ArchitectureNumber']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="number" name="number"/>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                                <div className="panel-body"></div>
                                <div className="col-sm-10 col-md-offset-1">
                                    <div className="col-sm-3"></div>
                                    <div className="col-sm-3 text-center">
                                        <button className="btn btn-success" onClick={this.submit}>{language()['submit']}</button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-8 hidden" id="addDiv">
                                <form id="addForm" className="form-horizontal">
                                    {/********父类ID*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['level']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="levelAdd"
                                                       name="levelAdd" disabled="true"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********父类ID*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['parentId']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="parentIdAdd"
                                                       name="parentIdAdd" disabled="true"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********ID*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> ID
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="idAdd" name="idAdd"
                                                       disabled="true"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********架构名称*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['SchemaName']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="nameAdd"
                                                       name="nameAdd"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********中文简称*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['shortName']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="shortNameAdd"
                                                       name="shortNameAdd"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********英文名称*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['enName']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="enNameAdd"
                                                       name="enNameAdd"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********英文简称*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['abbreviation']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="abbreviationAdd"
                                                       name="abbreviationAdd"/>
                                            </div>
                                        </div>
                                    </div>
                                    {/********架构编号*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-sm-3 control-label"> {language()['ArchitectureNumber']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <input type="text" className="form-control" id="numberAdd"
                                                       name="numberAdd"/>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div className="panel-body"></div>
                                <div className="col-sm-10 col-md-offset-1">
                                    <div className="col-sm-3"></div>
                                    <div className="col-sm-3 text-center">
                                        <button id="btnSubmit" className="btn btn-success" onClick={this.submitAdd.bind(this)}>{language()['submit']}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/orgStructure/orgStructure.js